module.exports = __webpack_public_path__ + "static/img/d4.cd6017d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/d4.png
// module id = /Z8v
// module chunks = 0